import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import userApi from "@/lib/userApi";
import { formatApiErrorDetail } from "@/lib/api";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await userApi.post("/account/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  const inputClass =
    "w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-800 outline-none transition-colors placeholder:text-slate-400 focus:border-primary focus:ring-2 focus:ring-primary/20";

  return (
    <Layout showTicker={false}>
      <Seo title="Забравена парола" noindex />
      <div className="mx-auto max-w-md px-4 py-16" data-testid="forgot-password-page">
        <Link to="/vhod" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-primary">
          <ArrowLeft className="h-4 w-4" />Назад към вход
        </Link>
        {sent ? (
          <div className="mt-8 text-center" data-testid="forgot-sent">
            <MailCheck className="mx-auto h-14 w-14 text-green-600" />
            <h1 className="mt-5 font-display text-2xl font-extrabold text-slate-900">Проверете пощата си</h1>
            <p className="mt-2 text-slate-600">
              Ако съществува профил с този имейл, изпратихме връзка за нова парола. Проверете и папка „Спам".
            </p>
          </div>
        ) : (
          <>
            <h1 className="mt-6 font-display text-2xl font-extrabold text-slate-900">Забравена парола</h1>
            <p className="mt-1 text-sm text-slate-500">Въведете имейла си и ще Ви изпратим връзка за нова парола.</p>
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
              <input type="email" className={inputClass} data-testid="forgot-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.bg" required />
              <button type="submit" disabled={busy} data-testid="forgot-submit" className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-[#0041A8] disabled:opacity-60">
                {busy && <Loader2 className="h-5 w-5 animate-spin" />}Изпрати връзка
              </button>
            </form>
          </>
        )}
      </div>
    </Layout>
  );
}
